export const formatProviderName = (firstName: string, lastName: string) => {
  return `${firstName} ${lastName}`.trim();
};
